<h2 mat-dialog-title>
    <span style="font-weight: 600;">{{'mysign-session-config.mysign-session-config' | translate}}</span>
    <button type="button" class="close" aria-label="Close" cdkFocusInitial (click)="cancel()">
      <span aria-hidden="true">&times;</span>
    </button>
</h2>
<mat-divider></mat-divider>
<form name="form" class="add-document-group" #f="ngForm" (ngSubmit)="f.form.valid && saveConfig()">
    <mat-dialog-content class="container mt-3">
        <div class="ml-2">
            <div class="mt-4">
            <label>{{ 'mysign-session-config.save_session' | translate }}</label>
            <nz-switch class="ml-3" [(ngModel)]="value" (ngModelChange)="changeForm($event)" [ngModelOptions]="{standalone: true}"
              nzCheckedChildren="{{ 'service_type.remind_configuration.on_status' |translate }}" nzUnCheckedChildren="{{ 'service_type.remind_configuration.off_status' | translate }}">
            </nz-switch>
            </div>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions align="center" class="my-2">
        <button mat-stroked-button color="primary" class="mr-3" type="button" (click)="cancel()">
          <mat-icon class="mr-0">cancel</mat-icon>{{'button.cancel' | translate}}
        </button>
        <button mat-raised-button [disabled]="f.form.invalid" color="primary" type="submit">
          <mat-icon class="mr-0">save</mat-icon>{{'button.confirm' | translate}}
        </button>
      </mat-dialog-actions>
</form>
